import React from 'react';

export const ChatDrawerContext = React.createContext();
ChatDrawerContext.displayName = 'Chat drawer context provider';

export const ChatDrawerProvider = ChatDrawerContext.Provider;
